import AuthRepo from "@/core/repos/auth.repo";
import { AppRoleRepo } from "@/core/repos/tables/app-role.repo";
import { AppUserRepo } from "@/core/repos/tables/app-user.repo";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import container from "@/lib/di/container";
import { Modal, Button, ConfigProvider, message, Form, Input } from "antd";
import { Dispatch, SetStateAction, useState, useEffect } from "react";

const appUserRepo = container.get(AppUserRepo);
const appRoleRepo = container.get(AppRoleRepo);
const authRepo = container.get(AuthRepo);

interface ChangeMyPasswordPayload {
    id: string,
    oldPassword: string,
    newPassword: string
}

interface ChangeMyPasswordModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
}

const INPUT_WIDTH = 450;

export const ChangeMyPasswordModal: React.FC<ChangeMyPasswordModalProps> = ({isModalOpen, setIsModalOpen}) => {
    const [loading, setLoading] = useState<boolean>(false)
    const userDetail = authRepo.useDetails();
    const [form] = Form.useForm<ChangeMyPasswordPayload>();

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const handleSave = async () => {
        setLoading(true);
        if (userDetail) {
            const result = await appUserRepo.changeMyPassword(userDetail.id, form.getFieldValue("oldPassword"), form.getFieldValue("newPassword"));
            if (result === true) {
                message.success({
                    content: "Đã cập nhật mật khẩu thành công!"
                })
                setIsModalOpen(false);
            } else {
                if (result === "01") {
                    message.error({
                        content: "Mật khẩu cũ của bạn không đúng!"
                    })
                } else {
                    message.error({
                        content: "Đổi mật khẩu thất bại"
                    })
                }

            }
        } else {
            message.error({
                content: "Cập nhật thất bại"
            })
        }
        setLoading(false);
    };

    const validatePasswords = (_: any, value: string): Promise<void> => {
        if (value && value !== form.getFieldValue('newPassword')) {
          return Promise.reject(new Error('Mật khẩu không giống nhau!'));
        }
        return Promise.resolve();
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            <Modal open={isModalOpen} onCancel={handleCancel} width={510} centered
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={[
                    <div key={1} className="w-full flex flex-row justify-end px-1.5">
                        <Button key="submit" type="primary" loading={loading}
                            style={{ 
                                background: "var(--primary-color)", 
                                paddingRight: 48, 
                                paddingLeft: 48, 
                                fontSize: 18,
                                fontWeight: 600,
                                paddingTop: 18, 
                                paddingBottom: 18,
                                }}
                            onClick={handleSave}
                        >
                            LƯU
                        </Button>
                    </div>,
                ]}
            >
                <div className="flex flex-row w-full items-start justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">ĐỔI MẬT KHẨU</p>
                </div>
                <div className="flex flex-row justify-center mt-6">
                    <Form<ChangeMyPasswordPayload>
                        name="basic"
                        className="flex flex-col items-start"
                        autoComplete="off"
                        labelAlign="left"
                        layout="vertical"
                        form={form}
                    >
                        <Form.Item<ChangeMyPasswordPayload>
                            name="oldPassword"
                            label="Mật khẩu cũ"
                            rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập mật khẩu cũ!',
                            },
                            ]}
                        >
                            <Input.Password style={{width: INPUT_WIDTH}} placeholder="Nhập mật khẩu cũ" />
                        </Form.Item>
                        <Form.Item<ChangeMyPasswordPayload>
                            name="newPassword"
                            label="Mật khẩu mới"
                            rules={[
                            {
                                required: true,
                                message: 'Vui lòng nhập mật khẩu mới!',
                            },
                            ]}
                        >
                            <Input.Password style={{width: INPUT_WIDTH}} placeholder="Nhập mật khẩu mới" />
                        </Form.Item>
                        <Form.Item
                            name="confirm"
                            label="Xác nhận mật khẩu"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                            {
                                required: true,
                                message: 'Vui lòng xác nhận mật khẩu!',
                            },
                            {
                                validator: validatePasswords,
                            },
                            ]}
                        >
                            <Input.Password style={{width: INPUT_WIDTH}} placeholder="Xác nhận mật khẩu" />
                        </Form.Item>
                    </Form>
                </div>
                <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
            </Modal>
        </ConfigProvider>
    )
} 